module.exports = __webpack_public_path__ + "static/assets/25cd56f3ff25cce57ab8e7fcac1cec97.svg";